import { Component } from "react";
import { withRouter } from "../../utils/withRouter";
import { connect } from "react-redux";
import { ToastContainer } from "react-toastify";

import VisitorHeader2 from "../../common_components/visitor_module_header2";
import VisitorDrawer from "../../common_components/visitor_module_drawer";
import VisitorTopMenu from "../../common_components/visitor_module_topmenu";

import HeaderWithLogo from "../../common_components/header_with_logo";
import ExhibitionDrawer from "../../common_components/admin_module_drawer";

import ExhibitorDrawer from "../../common_components/exhibitor_module_drawer";
import ExhibitorHeader from "../../common_components/exhibitor_module_header";
import ExhibitorTopMenu from "../../common_components/exhibitor_module_topmenu";

import AgentHeader from "../../common_components/agent_module_header";
import AgentDrawer from "../../common_components/agent_module_drawer";
import AgentTopMenu from "../../common_components/agent_module_topmenu";
import ConfirmationModal from "../../common_components/confirmationa_modal";
import Loader from "../../utils/Loader";

import { updatePassword_action } from "../../actions/user_login_auth_actions/user_login_auth_action";
import { toastError, toastSuccess } from "../../utils/constants";
import { newPasswordValidator } from "../../utils/Validator";


class ChangePassword2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            is_showOldpass: false,
            is_showNewpass: false,
            is_showConfirmpass: false,
            old_pass: "",
            new_pass: "",
            confirm_pass: "",
            old_passErr: "",
            new_passErr: "",
            confirmationObj: { message: '', buttonName: '', action: '' },
            popArg: [],
            isOpenConfirmationModal: false,
            confirm_passErr: ""
        };

        this.handleConfirmation = this.handleConfirmation.bind(this)
    }


    handleConfirmation(flag) {
        const { confirmationObj, popArg } = this.state;
        if (flag) {
            if (confirmationObj.action == 0) {
                this.updatePassword()
            }
        }
        this.setState({ isOpenConfirmationModal: false })
    }

    handleObscure(field) {
        this.setState(prev => ({
            [field]: !prev[field]
        }));
    }

    inputValidate() {
        const { old_pass, new_pass, confirm_pass } = this.state;

        if (!old_pass) this.setState({ old_passErr: "Please Enter Current Password" });
        if (!new_pass) this.setState({ new_passErr: "Please Enter New password" });
        if (!confirm_pass) this.setState({ confirm_passErr: "Please Enter Confirm Password" });

        if (new_pass) {
            const err = newPasswordValidator(new_pass);
            if (err) {
                this.setState({ new_passErr: err });
                return false;
            }
        }

        if (new_pass !== confirm_pass) {
            this.setState({ confirm_passErr: "New password and Confirm password should be same" });
            return false;
        }

        return true;
    }

    updatePassword() {
        const UserID = this.props.location?.state?.UserID || null;

        if (!this.inputValidate()) return;

        this.setState({ isLoading: true });

        this.props.updatePassword_action(this.state.old_pass.trim(), this.state.new_pass.trim(), JSON.parse(sessionStorage.getItem("loginDataSS")).UserID)
            .then(data => {
                this.setState({ isLoading: false });

                if (data.error != 1) {
                    toastSuccess("Password Changed Successfully");
                } else {
                    toastError(data.msg);
                }
            })
            .catch(() => this.setState({ isLoading: false }));
    }

    renderHeader(role) {
        switch (role) {
            case 1: return <ExhibitorHeader />;
            case 2: return <HeaderWithLogo />;
            case 3: return <VisitorHeader2 />;
            case 4: return <AgentHeader />;
            default: return null;
        }
    }

    renderDrawer(role) {
        switch (role) {
            case 1: return <ExhibitorDrawer />;
            case 2: return <ExhibitionDrawer />;
            case 3: return <VisitorDrawer />;
            case 4: return <AgentDrawer />;
            default: return null;
        }
    }

    renderTopMenu(role) {
        switch (role) {
            case 1: return <ExhibitorTopMenu />;
            case 3: return <VisitorTopMenu />;
            case 4: return <AgentTopMenu />;
            default: return null;
        }
    }

    render() {
        const {
            isLoading,
            old_pass, new_pass, confirm_pass,
            old_passErr, new_passErr, confirm_passErr,
            is_showOldpass, is_showNewpass, is_showConfirmpass, isOpenConfirmationModal
        } = this.state;

        const loginData = JSON.parse(sessionStorage.getItem("loginDataSS"));
        const RoleID = loginData?.RoleID;

        return (
            <>
                {isLoading && <Loader />}
                <ToastContainer />
                {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null}
                {this.renderHeader(RoleID)}
                {this.renderDrawer(RoleID)}

                <div className="main-content app-content mt-0">
                    {this.renderTopMenu(RoleID)}

                    <div className="side-app">
                        <div className="card card-outline-secondary-1 space-from-top">
                            <div className="card-header bg-white border-0 text-center">
                                <h5 className="mb-0 chsp p-2">Change Password</h5>
                            </div>

                            <div className="card-body">
                                <form autoComplete="off">

                                    {/* Old Password */}
                                    <div className="form-group mb-3 position-relative">
                                        <label>Current Password</label>
                                        <input
                                            type={is_showOldpass ? "text" : "password"}
                                            className="form-control"
                                            placeholder="Enter Your Old Password"
                                            value={old_pass}
                                            onChange={e => this.setState({ old_pass: e.target.value, old_passErr: "" })}
                                        />
                                        <span className="text-danger">{old_passErr}</span>

                                        <i className="fa fa-eye"
                                            onClick={() => this.handleObscure("is_showOldpass")}
                                            style={{ position: "absolute", top: 32, right: 5, color: "gray" }}
                                        />
                                    </div>

                                    {/* New Password */}
                                    <div className="form-group mb-3 position-relative">
                                        <label>New Password</label>
                                        <input
                                            type={is_showNewpass ? "text" : "password"}
                                            className="form-control"
                                            placeholder="Enter New Password"
                                            maxLength="20"
                                            value={new_pass}
                                            onChange={e => this.setState({ new_pass: e.target.value, new_passErr: "" })}
                                        />
                                        <span className="text-danger">{new_passErr}</span>

                                        <i className="fa fa-eye"
                                            onClick={() => this.handleObscure("is_showNewpass")}
                                            style={{ position: "absolute", top: 32, right: 5, color: "gray" }}
                                        />
                                    </div>

                                    {/* Confirm Password */}
                                    <div className="form-group mb-3 position-relative">
                                        <label>Confirm Password</label>
                                        <input
                                            type={is_showConfirmpass ? "text" : "password"}
                                            className="form-control"
                                            placeholder="Enter New Password again"
                                            maxLength="20"
                                            value={confirm_pass}
                                            onChange={e => this.setState({ confirm_pass: e.target.value, confirm_passErr: "" })}
                                        />
                                        <span className="text-danger">{confirm_passErr}</span>

                                        <i className="fa fa-eye"
                                            onClick={() => this.handleObscure("is_showConfirmpass")}
                                            style={{ position: "absolute", top: 32, right: 5, color: "gray" }}
                                        />
                                    </div>

                                    <button
                                        type="button"
                                        className="btn btn-primary rounded-0 d-block"
                                        // onClick={() => this.updatePassword()}
                                        onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to Submit?`, buttonName: "Submit", action: 0 }, popArg: [] })}
                                        style={{ padding: "4px 25px" }}
                                    >
                                        Change Password
                                    </button>

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default withRouter(connect(null, { updatePassword_action })(ChangePassword2));
